import { uploadTransactionHeaders } from './uploadTransactionHeaders';

export const initialSteps = [
    {
        target: '[data-tour="upload-area"]',
        content:
            'Click “Upload Transaction” to begin importing your CSV file. Your CSV file should have one amount column.',
        placement: 'top',
        disableBeacon: false,
        disableOverlay: true,
    },
];

export const accountSelectionStep = [
    {
        target: '[data-tour="account-selection"]',
        content: 'First, select the bank account to import transactions into',
        placement: 'top',
        disableBeacon: false,
        disableOverlay: true,
    },
];

export const bankImportButtonStep = [
    {
        target: '[data-tour="import-button"]',
        content: 'Click Import to save your mapped transactions to the selected account.',
        placement: 'top',
        disableBeacon: false,
        disableOverlay: true,
    },
];

export const contentMap = {
    'Date *': 'Choose transaction date from your csv file (MM/DD/YYYY format).',
    'Description *': 'Choose description from your csv file.',
    'Amount *':
        'Choose amount from your csv file. Use negative values for amount spent and positive values for cash in.',
    // 'Merchant Name': 'If your bank csv includes the vendor or store name, you can map it here.',
    // Type: 'If your bank csv includes “Credit” or “Debit”, you can map it here.',
    // 'Card Name': 'If your bank csv includes card name, you can map it here.',
    'Card number (or 4 digits)':
        'Last 4 digits of the card used if virtual cards are used. This is important as it helps track card usage during reconciliation.',
    // 'Transaction ID': 'Map this to a unique transaction reference, if available.',
};

export function generateMappingSteps() {
    const steps = [
        {
            target: '[data-tour="account-selection"]',
            content: 'Make sure you have selected the correct bank account for these transactions.',
            placement: 'top',
            disableBeacon: false,
            disableOverlay: true,
        }
    ];
    
    const mappingSteps = uploadTransactionHeaders.map((ch) => {
        const slug = ch
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '');

        return {
            target: `[data-tour="map-${slug}"]`,
            content: contentMap[ch],
            placement: 'bottom',
            disableBeacon: false,
            disableOverlay: true,
            offset: -30,
        };
    });
    
    return [...steps, ...mappingSteps];
}
